import React from "react";
import CrudResource from "./CrudResource";

const fields = [
  { key: "slug", label: "Slug" },
  { key: "title_tr", label: "Başlık (TR)" },
  { key: "title_en", label: "Başlık (EN)" },
  { key: "description_tr", label: "Açıklama (TR)", type: "textarea", span: 2 },
  { key: "description_en", label: "Açıklama (EN)", type: "textarea", span: 2 },
  { key: "details_tr", label: "Detaylar (TR)", type: "textarea", span: 2 },
  { key: "details_en", label: "Detaylar (EN)", type: "textarea", span: 2 },
  { key: "cover_image", label: "Kapak Görseli", type: "media", accept: "image", span: 2 },
  { key: "cover_video", label: "Kapak Videosu", type: "media", accept: "video", span: 2 },
  { key: "icon", label: "İkon (Sparkles/Camera/Film...)" },
  { key: "span", label: "Bento Boyut", type: "select", options: [
    { value: "normal", label: "Normal" }, { value: "wide", label: "Wide" }, { value: "tall", label: "Tall" }
  ]},
  { key: "seo_title", label: "SEO Başlığı", span: 2 },
  { key: "seo_description", label: "SEO Açıklaması", type: "textarea", span: 2 },
  { key: "order", label: "Sıra", type: "number" },
  { key: "active", label: "Aktif", type: "checkbox" },
];

const defaults = { slug: "", title_tr: "", title_en: "", description_tr: "", description_en: "", cover_image: "", icon: "Sparkles", span: "normal", order: 100, active: true };

export default function AdminServices() {
  return <CrudResource resource="services" publicPath="services" title="Hizmetler" fields={fields} defaults={defaults} />;
}
